<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!contract">
      <span class="loader"></span>
    </span>
    <div v-if="contract" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="label"
      >
        <tab-pane title="label" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <contract-view-global
            :contract="contract"
            @onContractUpdated="get"
            @onEditContract="editContract"
            @onDeleteContract="deleteContract"
          />
        </tab-pane>
        
        <tab-pane
          title="files"
          id="2"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_CONTRACT_FILES)"
        >
          <span slot="title">
            <i class="fa fa-file" aria-hidden="true"></i>
            {{ $t("CONTRACTS.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-contract-files-component :contract="contract" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <contract-view-logs :contract="contract" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import ContractViewLogs from "../partials/ContractViewLogs.vue";
import ContractViewGlobal from "../partials/ContractViewGlobal.vue";
import ListContractFilesComponent from "./files/ListContractFilesComponent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    ContractViewLogs,
    ContractViewGlobal,
    ListContractFilesComponent
  },

  mixins: [],

  props: {
    contractId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      contract: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("contracts/get", this.contractId);
        this.contract =
          this.$store.getters["contracts/contract"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    editContract(contract) {
      this.$emit("onEditContract", contract);
    },
    deleteContract(contract) {
      this.$emit("onDeleteContract", contract);
    },
  },
};
</script>
